import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormGroup, UntypedFormGroup } from "@angular/forms";
import { FormService } from "../../services/form.service";
import { MatDialog } from "@angular/material/dialog";
import { TrackingService } from "../../services/tracking.service";

@Component( {
	selector: 'app-consent-movers-list',
	templateUrl: './consent-movers-list.component.html',
	styleUrls: ['./consent-movers-list.component.scss']
} )
export class ConsentMoversListComponent {

	@Input() movers!: FormArray<FormGroup>;
	@Input() viewMode: 'default' | 'full' = 'default';
	@Output() openModal = new EventEmitter<void>();
	@Input() form!: FormGroup
	@Input() displayedIndices: number[] = [];

	consentMovers !: UntypedFormGroup
	formGroupName : string = 'consentMovers'
	readonly maxSelections: number = 5
	private hasTrackedInteraction: boolean = false;
	private hasTrackedModalOpen: boolean = false;

	constructor( 
		public formService: FormService,
		private trackingService: TrackingService
	) {

	}

	public ngOnInit(): void {
		this.setupSelectionLimit();
	}

	private setupSelectionLimit(): void {
		this.movers.controls.forEach(control => {
			control.get('checkbox')?.valueChanges.subscribe(checked => {
				if( checked && this.getSelectedCount() > this.maxSelections ) {
					control.get( 'checkbox' )?.setValue( false, { emitEvent: false } );
				}
			} );
		} );
	}

	public onCheckboxChange(event: Event, control: FormGroup): void {

		// Track interaction only if not in modal and not already tracked
		if( this.viewMode === 'default' && ! this.hasTrackedInteraction ) {
			const checkbox = event.target as HTMLInputElement;
			this.trackingService.sendGTMEvent( {
				event: 'mover_checkbox_interaction',
				event_category: 'form_interaction',
				event_action: 'checkbox_click',
				event_label: control.get('_name')?.value,
				selected: checkbox.checked
			} );
			this.hasTrackedInteraction = true;
		}
	}

	public getSelectedCount(): number {
		return this.movers.controls.filter(control => control.get('checkbox')?.value).length;
	}

	public canSelect(control: FormGroup): boolean {
		return control.get('checkbox')?.value || this.getSelectedCount() < this.maxSelections;
	}

	public triggerModal() {
		// Track modal open only if not already tracked
		if( ! this.hasTrackedModalOpen ) {
			this.trackingService.sendGTMEvent( {
				event: 'mover_modal_open',
				event_category: 'form_interaction',
				event_action: 'open_modal',
				event_label: 'View other moving companies'
			} );
			this.hasTrackedModalOpen = true;
		}
		
		this.openModal.emit();
	}

	public getStars( rating: number ) {

		rating = rating / 2;
		const stars: string[] = [];
		const fullStars = Math.floor(rating);
		const hasHalfStar = rating % 1 !== 0;
		const totalStars = 5;

		for (let i = 0; i < fullStars; i++) {
			stars.push('assets/images/stars/star-full.png');
		}

		if (hasHalfStar) {
			stars.push('assets/images/stars/star-half.png');
		}

		while (stars.length < totalStars) {
			stars.push('assets/images/stars/star-empty.png');
		}

		return stars;
	}
}
